import React, { useEffect, useState } from "react";
import Select from "../../../components/Form/Select";
import { useAuth } from "../../../hooks/auth";
import { MOPAR_PLANT_ID, MVM_JIS_STATUS, PORTO_REAL_PLANT_ID, FIASA_PLANT_ID, FIAPE_PLANT_ID } from "../../../utils/constants";

type Props = any;

const SelectMvmType: React.FC<Props> = ({ name, control, multiple, style, label}) => {
  
  const [mvmTypeList, setMvmTypeList] = useState<any>([])
  const { user } = useAuth();
  
  useEffect(() => {

    var status = MVM_JIS_STATUS

    // Mopar:
    // Não Jis
    // Carreta
    if (+user.company.plantID === MOPAR_PLANT_ID) {      
      status = status.filter((f : any) => 
        f.code === 'K' || f.code === 'C'
        )
    }

    // Fiasa 
    // JIS
    // Não Jis
    // E-Kamban
    // Interno
    if (+user.company.plantID === FIASA_PLANT_ID) {
      status = status.filter((f : any) => 
        f.code === 'J' || 
        f.code === 'K' || 
        f.code === 'E' || 
        f.code === 'I' ||
        f.code === 'F')
    }

    // Fiape e Porto Real:
    // Não Jis
    if ([FIAPE_PLANT_ID, PORTO_REAL_PLANT_ID].includes(+user.company.plantID)) {       
      status = status.filter((f : any) => 
        f.code === 'K')
    }

    setMvmTypeList(status)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Select 
      label={label} 
      name={name}
      control={control} 
      options={mvmTypeList}
      multiline={multiple}
      style={style ? style : {width: '100%'}}/>
  )
}

export default SelectMvmType;
